import { useState, useEffect } from 'react';
import { FaTasks } from 'react-icons/fa';

const WarmupComercialCountCard = () => {
    const [warmupCount, setWarmupCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const API_URL = process.env.REACT_APP_API_URL || 'https://sic-conti-backend.vercel.app';


    const fetchWarmupCount = async () => {
        try {
            const response = await fetch(`${API_URL}/api/listar_warmup?etapa=Resposta Comercial`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`Erro: ${response.status}`);
            }

            const data = await response.json();
            setWarmupCount(data.data.length); // Captura o total de processos
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchWarmupCount();
    }, []);

    return (
        <div className="w-full max-w-sm bg-white rounded-lg shadow-md p-4 flex items-center">
            <div className="text-blue-500 bg-blue-100 p-3 rounded-full">
                <FaTasks size={24} />
            </div>
            <div className="ml-4">
                <h2 className="text-lg font-semibold text-gray-800">Processos em Aberto</h2>
                {loading ? (
                    <p className="text-gray-500 text-sm">Carregando...</p>
                ) : error ? (
                    <p className="text-red-500 text-sm">{error}</p>
                ) : (
                    <p className="text-2xl font-bold text-gray-700">{warmupCount}</p>
                )}
            </div>
        </div>
    );
};

export default WarmupComercialCountCard;
